module.exports = __webpack_public_path__ + "img/but_login_test.a8d2f15e.png";